import React, { useState } from 'react';
import styles from './CouponInput.module.css';
import API from '../../api/api';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase.config';
import { useUser } from '../../context/UserContext';

const CouponInput: React.FC = () => {
  const [coupon, setCoupon] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useUser();
  const navigate = useNavigate();

  const handleApply = async () => {
    if (!coupon) return;

    setLoading(true);
    setMessage('');

    try {
      const { data } = await API.post('/subscription/apply-coupon', { couponCode: coupon });
      setCoupon("");
      setMessage(`✅ ${data.message || 'Coupon applied successfully!'}`);

      // Refresh Firebase auth token without sign out
      if (auth.currentUser) {
        await auth.currentUser.reload(); // Refresh the user's ID token
        const updatedUser = auth.currentUser;
        
        // Get the updated ID token
        const token = await updatedUser.getIdToken(true);
        
        // Update local storage
        localStorage.setItem("token", token);
        
        // Update user context with premium status
        setUser({
          ...user!,
          isPremium: true,
        });

        // Optional: Redirect to dashboard or refresh page
        navigate("/dashboard", { replace: true });
      }
    } catch (err: any) {
      setMessage(`❌ ${err.response?.data?.message || err.message || 'Something went wrong.'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Have a Coupon?</h3>
      <input
        type="text"
        value={coupon}
        onChange={(e) => setCoupon(e.target.value)}
        placeholder="Enter coupon code"
        className={styles.input}
      />
      <button
        onClick={handleApply}
        disabled={loading || !coupon}
        className={styles.button}
      >
        {loading ? 'Applying...' : 'Apply Coupon'}
      </button>
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default CouponInput;